import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-titleæ é¢
 * 
 * æè¿°ä¸æ®µæå­æåå®¹çæå­ã
 * 
 * éè¦æè¿°ä¸æ®µæå­æåå®¹çæ é¢ã
 * 
 */
@Component({
    selector: 'fc-title',
    template: `
    <div *ngIf="fcLabel!==undefined" class="fc-title"  [style.width]="fcWidth" 
        [ngClass]="{'fc-hasline':fcHasLine==='Y',
        'fc-bottom-border':fcBorder==='bottom','fc-title-small':fcSize === 'small','fc-title-default':fcSize === 'default',
        'fc-title-large':fcSize === 'large','fc-title-left':fcLayout==='left','fc-title-center':fcLayout==='center',
        'fc-title-right':fcLayout==='right'}">
        <div class="fc-title-in"><i *ngIf="fcIcon!==undefined&&fcIcon!==null&&fcIcon!==''" class="icon iconfont" [ngClass]="fcIcon"></i><span style="padding-left: 3px;">{{fcLabel}}</span></div>
        <div class="fc-title-extra"><ng-content select="[fcextra]"></ng-content></div>
    </div>
    <div class="fc-subtitle" 
        [ngClass]="{'fc-hasline':fcHasLine==='Y','fc-subtitle-small':fcSize === 'small','fc-subtitle-default':fcSize === 'default','fc-subtitle-large':fcSize === 'large','fc-subtitle-center':fcLayout==='center'}">
        <ng-content select="[fcsubtitle]"></ng-content>
        <span>{{fcSubtitle}}</span>
    </div>
    `,
    styles: [
        `
    .fc-title{
        color:#333333;
        margin-top:10px;
        margin-bottom:10px;
        position:relative;
    }
    .fc-title .icon{
        color:#a3afb7;
        margin-right: 10px;
        font-size:16px;
    }
    .fc-title-extra{
        position:absolute;
        bottom:0;
        right:0;
    }
    .fc-title-in span{
        font-weight: 700;
    }
    .fc-title-small .fc-title-in span{
        font-size:12px;
    }
    .fc-title-default .fc-title-in span{
        font-size:14px;
    }    
    .fc-title-large .fc-title-in span{
        font-size:18px;
    }
    .fc-subtitle{
        color:#666666;
        padding-left:10px;
        margin-top:10px;
        margin-bottom:10px;
    }
    .fc-subtitle label{
        font-weight:bold;
    }
    .fc-subtitle-small{
        font-size:12px;
    }
    .fc-subtitle-default{
        font-size:14px;
    }    
    .fc-subtitle-large{
        font-size:18px;
    }
   .fc-hasline{
        position:relative;
        border-left:3px solid #108ee9;
    }
    .fc-hasline:after{
        width: 100%;
        height: 100%;
        content:'';
        display:block; 
        position:absolute;
        left:0;
        top:0;
    }
    .fc-title-left{
        padding-left:5px;
    }
    .fc-title-right{
        padding-right:5px;
    }
    .fc-title-center{
        width:100%;
        height:20px;
        line-height:20px;
        text-align:center;
        margin:0 auto;
    }
    .fc-title-center:after{
        display:none;
    }
    .fc-title-center .fc-title-in {
        width: 100%;
        position: absolute;
        left: 0;
        top: 7px;
        text-align: center;
    }
    .fc-title-center .fc-title-in span{
        padding-left:20px;
        padding-right:20px;
        background-color:#EEF7FC;
        color:#F4121E;
        font-size:22px;
    }
    .fc-title-right {
        text-align: right;
    }
    .fc-subtitle-center{
        width:80%;
        margin:0 auto;
        padding-top:20px;
        padding-bottom:5px;
        text-aligin:left;
        font-size:16px;
    }
    .fc-label:last-child {
        text-align:right;
    }
    .fc-bottom-border {
        width:100%;
        border-bottom: 1px solid #ebedf0;
        margin-left:0;
        font-weight:700;
    }
    `]
})
export class FctitleComponent extends FcinputComponent {
    /** å¾æ  */
    @Input()
    fcIcon: string;
    /** æ é¢ */
    @Input()
    fcLabel: string;
    /** å¯æ é¢ */
    @Input()
    fcSubtitle: string;
    /** æ¯å¦æå·¦ä¾§ç«æ¡ */
    @Input()
    fcHasLine: string;
    _hasLine: boolean;
    /** æ¯å¦æä¸è¾¹æ¡ */
    @Input()
    fcBorder: string;
    /** å¸å± */
    @Input()
    fcLayout: string;
    /** å®½åº¦ */
    @Input()
    fcWidth: string = "100%";
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-title');

    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        /**æ é¢ä½ç½®*/
        if (this.fcLayout === undefined) {
            this.fcLayout = TitleLayout.LEFT;
        } else if (this.fcLayout === 'left') {
            this.fcLayout = TitleLayout.LEFT;
        } else if (this.fcLayout === 'center') {
            this.fcLayout = TitleLayout.CENTER;
        } else if (this.fcLayout === 'right') {
            this.fcLayout = TitleLayout.RIGHT;
        }
        /**æ é¢é»è®¤åºé¨æ²¡ææ¨ªçº¿*/
        if (this.fcBorder === undefined) {
            this.fcBorder = TitleBorder.NULL;
        } else if (this.fcBorder === 'top') {
            this.fcBorder = TitleBorder.TOP;
        } else if (this.fcBorder === 'bottom') {
            this.fcBorder = TitleBorder.BOTTOM;
        }
        /**æ é¢é»è®¤æå·¦ä¾§æ¨ªçº¿*/
        this._hasLine = this.fcHasLine ? this.fcHasLine === 'Y' : true
    }
    _afterParentInit() {
        /**å¦æè®¤ä¸ºNå·¦ä¾§æ²¡ææ¨ªçº¿*/
        if (this.fcHasLine === 'N') {
            this._hasLine = false;
        }else{
            this._hasLine = true;
        }
    }
}
export const TitleLayout = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
}
export const TitleBorder = {
    TOP: 'top',
    BOTTOM: 'bottom',
    NULL: 'null'

}
export interface fcsubtitleOption {
    label?: string;
    content?: string;
}
